export enum SettingsSlices {
	Tenant = "tenantSettings",
	Application = "applicationSettings",
	User = "userSettings",
}
